import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsErrores} from '../cls-errores';
import {ClsArbolPartida, ClsRenumerarRenglon} from '../cls-partida';
import {ClsGuardarConceptosPartida} from "../cls-concepto";

export class ClsPeticionRegistraActualizaPartidas extends ClsPeticionPresupuestos {
  IdOrganizacion?: bigint;
  Catalogo: ClsArbolPartida[];
}
export class ClsRespuestaRegistraActualizaPartidas {
  PartidasIds: ClsArbolPartida[];
  Errores: ClsErrores;
}
export class ClsRespuestaRegistraActualizaPartidasDuplicadas {
  Partidas: ClsArbolPartida[];
  Errores: ClsErrores;
}

export class ClsRespuestaTodasLasPartidas {
  LsCatalogo: ClsArbolPartida[];
  Errores: ClsErrores;
}
export class ClsPartidasStorageZip {
  Partidas: string;
  Errores: ClsErrores;
}

export class ClsPeticionDuplicarPartidas extends ClsPeticionRegistraActualizaPartidas {
  PartidaSeleccionada: ClsArbolPartida;
  PartidasConceptos: ClsGuardarConceptosPartida[];
  VecesADuplicar: number;
}

export class ClsPeticionUnirPpto extends ClsPeticionPresupuestos {
  Catalogo: any;
  BorrarPpto: boolean;
}
export class ClsPeticionRenumerarRenglon extends ClsPeticionPresupuestos {
  Partidas: ClsRenumerarRenglon[];
}

